<section class="page-hero certificates-hero-pro">
    <div class="certificates-hero-bg"></div>

    <div class="container">
        <div class="certificates-hero-content">
            <span class="eyebrow"><i></i> Certificates & Compliance</span>

            <h1>Verified documents for industrial confidence.</h1>

            <p>
                Upload IOSC certificates as PDF files and provide customers with fast downloadable
                proof of quality, compliance and operational capability.
            </p>
        </div>
    </div>
</section>

<section class="section certificates-section-pro">
    <div class="container">

        <div class="section-head reveal">
            <div>
                <span class="section-kicker">Document Library</span>
                <h2>Certificates, compliance and company documentation.</h2>
            </div>

            <p>
                Customers can view IOSC compliance documents and download PDF versions directly from this page.
            </p>
        </div>

        <div *ngIf="loading" style="padding:20px 0">
            Loading certificates...
        </div>

        <div *ngIf="errorMessage" class="alert error">
            {{ errorMessage }}
        </div>

        <div class="cert-filter-bar cert-filter-pro reveal" *ngIf="!loading && !errorMessage">
            <button type="button"
                    *ngFor="let cat of categories"
                    [class.active]="selectedCategory === cat"
                    (click)="applyFilter(cat)">
                {{ cat }}
            </button>
        </div>

        <div class="cert-grid cert-grid-clean" *ngIf="!loading && !errorMessage">
            <article class="cert-card cert-card-pro cert-card-clean reveal" *ngFor="let c of filteredCertificates">

                <div class="cert-content">
                    <span class="cert-status">{{ c.category }}</span>

                    <h3>{{ c.title }}</h3>

                    <p>{{ c.description }}</p>
                </div>

            </article>
        </div>

        <div *ngIf="!loading && !errorMessage && filteredCertificates.length === 0" style="padding:20px 0">
            No certificates found.
        </div>

    </div>
</section>